import React from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Grid,
  Typography,
  Button,
  Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { SPECIAL_REPORT_TABS } from "../constants/chartConstants";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    width: "600px",
    height: "770px",
    border: "2px solid transparent",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflow: "auto",
  },
}));

/**
 * Modal component for drag-and-drop chart ordering
 */
const ChartOrderModal = ({
  open,
  onClose,
  graphTemplate,
  reportTab,
  onDragEnd,
  onToggleChart,
  onUpdateOrder,
}) => {
  const classes = useStyles();

  const handleToggleChart = (chartId, checked) => {
    if (onToggleChart) {
      onToggleChart(chartId, checked);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-describedby="transition-modal-description"
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <Grid container className={classes.paper}>
          <Grid item xs={12} style={{ textAlign: "left" }}>
            <Typography
              id="keep-mounted-modal-title"
              className="chartmodal_title"
              variant="h6"
              component="h2"
            >
              Drag and Drop Chart Order
              <p>Drag and drop the row to change the order of the chart</p>
            </Typography>

            <div>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {graphTemplate.map((item, index) => {
                        const isSpecialTab =
                          SPECIAL_REPORT_TABS.includes(reportTab);
                        const isLactationCurveChart =
                          item.id === "lactationcurvechart";

                        // Skip lactation curve chart for special tabs
                        if (isSpecialTab && isLactationCurveChart) {
                          return null;
                        }

                        return (
                          <Draggable
                            key={item.key}
                            draggableId={String(item.key)}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  padding: "3px 10px",
                                  marginTop: "5px",
                                  borderBottom:
                                    "1px solid rgba(128, 128, 120, 0.2)",
                                  ...provided.draggableProps.style,
                                }}
                              >
                                {item.name === "Test Day Milk"
                                  ? "Milk Production"
                                  : item.name}
                                <span className="icon-right">
                                  <Switch
                                    id={item.id}
                                    size="small"
                                    value={graphTemplate[index].value}
                                    checked={graphTemplate[index].value}
                                    className="modal-switch"
                                    onChange={(event) =>
                                      handleToggleChart(
                                        item.id,
                                        event.target.checked
                                      )
                                    }
                                  />
                                  <DragHandleIcon />
                                </span>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <div className="chart_modal_action">
                  <Button
                    variant="contained"
                    className="button"
                    type="button"
                    size="small"
                    onClick={onUpdateOrder}
                  >
                    Update Chart Order
                  </Button>
                </div>
              </DragDropContext>
            </div>
          </Grid>
        </Grid>
      </Fade>
    </Modal>
  );
};

export default ChartOrderModal;
